import { Component, Inject, Injector, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BlocState, ShowPopUpLoadingState } from '../../bloc/base-bloc';
import { PopupCallerCallBack } from '../../common';
import { LoadingService, PopupService } from '../../helper';
import { BaseComponent } from '../base-component/base.component';
import { ButtonCaller } from '../shared-button-component/shared-button.component';

@Component({
  standalone: true,
  selector: 'app-base-popup-component',
  template: ``,
})
export class BasePopUpComponent<T> extends BaseComponent {
  afterClosePopupObject: object = null;
  // dialogRef parameter that is passed as a input from popup.component to ng-template the render the popup content to close the popup by the reference
  @Input() matDialogRef: MatDialogRef<any>;
  @Input() initializeCaller: PopupCallerCallBack<T>;

  constructor(
    @Inject(String) protected override translationArr: string[] = [],
    protected override injector: Injector = null
  ) {
    super(translationArr, injector);
  }

  // this method have a dialogRef parameter that is passed as a input from popup.component to ng-template the render the popup content to close the popup by the reference
  onClose(dialogRef: MatDialogRef<any>): void {
    dialogRef.close(this.injector.get(PopupService).afterClosePopupObject);
    this.injector.get(PopupService).afterClosePopupObject = null;
  }

  closePopupCallback(): ButtonCaller {
    return () => this.onClose(this.matDialogRef);
  }

  // protected
  protected onHandlePopupState(state: BlocState): void {
    super.onHandleBlocState(state);
    // handle loading of the popup by pass values to singleton service
    this.injector.get(LoadingService).loadingPopup.next(false);
    if (state instanceof ShowPopUpLoadingState) {
      this.injector.get(LoadingService).loadingPopup.next(true);
    }
  }

  protected setAfterCloseDialogValue(): void {
    this.injector.get(PopupService).afterClosePopupObject = this.afterClosePopupObject;
  }
}
